// extracted by mini-css-extract-plugin
module.exports = {"jackpot":"Jackpot__jackpot--3Ya","title":"Jackpot__title--oMC","shine":"Jackpot__shine--1ML","sparkle":"Jackpot__sparkle--284"};